import { Box, IconButton, Typography, useTheme } from '@mui/material';
import ExoDialog from '../../../components/exo/ExoDialog';
import ExoForm from '../../../components/exo/ExoForm';
import RenderHTML from '../../../components/preview/RenderHTML';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../../global/theme/tokens';
import EditIcon from '@mui/icons-material/Edit';
import { useState } from 'react';
import { API_PATCH, DBRequest, useConfig } from '../../../api/api';

export const ImportantNote = ({ apiData, setApiData, path }) => {
  const config = useConfig();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fields = [
    {
      label: t('note'),
      type: 'richTextEditor',
      key: 'note',
    },
  ];

  function handleSubmit(data) {
    DBRequest({
      config,
      path,
      method: API_PATCH({ note: data.note }),
      onResponse: handleResponse,
      onLoading: setIsLoading,
    });
  }

  function handleResponse(data) {
    setApiData(data);
    setOpen(false);
  }

  if (!apiData) return;
  const { note } = apiData.data;
  return (
    <Box
      className="pb-2 relative"
      sx={{
        '& .editButton': {
          transition: '0.3s ease',
          bgcolor: colors.success + '30',
          color: colors.success,
          border: `1px solid ${colors.success}80`,
          opacity: 0,
          transform: 'translate(-5px)',
          position: 'absolute',
        },
        ':hover': {
          '& .editButton, & .delButton': {
            opacity: 1,
            transform: 'translate(0px)',
          },
        },
      }}
    >
      <IconButton
        onClick={() => setOpen(true)}
        size="small"
        className="editButton right-2"
      >
        <EditIcon sx={{ fontSize: '15px' }} />
      </IconButton>
      <Typography fontWeight={600}>{t('Important Informations')}</Typography>
      <Box className="pl-2">
        <RenderHTML HTML={note} />
      </Box>
      <ExoDialog limitWidth open={open} onClose={() => setOpen(false)}>
        <ExoForm
          fields={fields}
          header={t('Important Informations')}
          startDataCollection={apiData?.data}
          onCancel={() => setOpen(false)}
          onSubmit={handleSubmit}
          noDifferences
          isLoading={isLoading}
        />
      </ExoDialog>
    </Box>
  );
};
